import { schema } from 'normalizr';

export const ENTITY_REDUCER_KEY = 'drivers';
export const COLLECTION_REDUCER_KEY = ENTITY_REDUCER_KEY;

export const entity = new schema.Entity(ENTITY_REDUCER_KEY);
export const entities = new schema.Array(entity);
